import { ReportType, ReportConfig } from './types';
import { ReportGroupings, ReportMetrics } from '../modal-settings/index';

const GROUPINGS_TOOLTIP = 'Группировка — это возможность сгруппировать регистрации пользователей по определённым условиям и посмотреть их данные по 60 метрикам. В SCANе около 70 различных группировок. <a href="https://doc.scananalytics.ru/otchety/gruppirovki/" rel="noopener noreferrer" target="_blank">Подробнее</a>.';

const METRICS_TOOLTIP = 'Метрики — это показатель выбранных группировок. В сервисе около 60 разных показателей. <a href="https://doc.scananalytics.ru/otchety/metriki/" rel="noopener noreferrer" target="_blank">Подробнее</a>.';

const TABLE_TOOLTIP = 'Таблица позволяет отобразить данные по 70 различным группировкам и 60 метрикам. Так же можно одну группировку вложить в другую и таких уровней можно сделать неограниченное количество. <a href="https://doc.scananalytics.ru/otchety/#412-%D1%82%D0%B0%D0%B1%D0%BB%D0%B8%D1%86%D0%B0" rel="noopener noreferrer" target="_blank">Подробнее</a>.';

export const reportConfigs: Record<ReportType, Omit<ReportConfig, 'GroupingsComponent' | 'MetricsComponent'>> = {
    universal: {
        tableId: 'universal_table',
        groupingsTooltip: GROUPINGS_TOOLTIP,
        metricsTooltip: METRICS_TOOLTIP,
        tableTooltip: TABLE_TOOLTIP,
        hasAdsGroups: true,
    },
    order: {
        tableId: 'order_table',
        groupingsTooltip: GROUPINGS_TOOLTIP,
        metricsTooltip: METRICS_TOOLTIP,
        tableTooltip: TABLE_TOOLTIP,
        hasAdsGroups: false,
    },
    payment: {
        tableId: 'payment_table',
        groupingsTooltip: GROUPINGS_TOOLTIP,
        metricsTooltip: METRICS_TOOLTIP,
        tableTooltip: TABLE_TOOLTIP,
        hasAdsGroups: false,
    },
    ad: {
        tableId: 'ad_table',
        groupingsTooltip: GROUPINGS_TOOLTIP,
        metricsTooltip: METRICS_TOOLTIP,
        tableTooltip: TABLE_TOOLTIP,
        hasAdsGroups: false,
    },
    webinar: {
        tableId: 'webinar_table',
        groupingsTooltip: GROUPINGS_TOOLTIP,
        metricsTooltip: METRICS_TOOLTIP,
        tableTooltip: TABLE_TOOLTIP,
        hasAdsGroups: false,
    },
    visit: {
        tableId: 'visit_table',
        groupingsTooltip: GROUPINGS_TOOLTIP,
        metricsTooltip: METRICS_TOOLTIP,
        tableTooltip: TABLE_TOOLTIP,
        hasAdsGroups: false,
    },
};

export const getReportConfig = (reportType: ReportType) => {
    return {
        ...reportConfigs[reportType],
        GroupingsComponent: ReportGroupings,
        MetricsComponent: ReportMetrics,
    };
};
